import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

export const deleteQuestion = async (question_id: number) => {
  const response = await axiosInstance.delete(`/question/${question_id}`)
  return response.data
}

export const useDeleteQuestion = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['deleteQuestion'],
    mutationFn: deleteQuestion,
  })

  return {
    deleteQuestionAsync: mutateAsync,
    isDeletingQuestion: isPending,
  }
}
